export default __webpack_public_path__ + "assets/46e4576639f60038865034ee8d583542.jpg";